import { Star, Quote } from "lucide-react";
import { useLang } from "../context/LanguageContext";

const testimonials = [
  {
    name: "Puan Rosnah", area: "Shah Alam", rating: 5,
    en: "Dr. Azim came to check on my mother who is bedridden. Very gentle, professional and explained everything clearly. Highly recommended!",
    ms: "Dr. Azim datang memeriksa ibu saya yang terlantar. Sangat lembut, profesional dan menerangkan semuanya dengan jelas. Sangat disyorkan!",
  },
  {
    name: "Encik Faizal", area: "Petaling Jaya", rating: 5,
    en: "Booked a blood checkup for my father. The doctor arrived on time and the whole process was smooth. Results explained via WhatsApp.",
    ms: "Menempah pemeriksaan darah untuk ayah saya. Doktor tiba tepat pada masanya dan seluruh proses berjalan lancar. Keputusan diterangkan melalui WhatsApp.",
  },
  {
    name: "Mdm. Tan Siew Lee", area: "Subang Jaya", rating: 5,
    en: "After my surgery I needed wound dressing every few days. So convenient not having to travel — the doctor is skilled and caring.",
    ms: "Selepas pembedahan saya perlukan rawatan luka setiap beberapa hari. Sangat mudah tanpa perlu bergerak — doktornya mahir dan prihatin.",
  },
  {
    name: "Puan Aminah", area: "Klang", rating: 5,
    en: "Very easy to book through WhatsApp. The doctor was patient with my elderly mother and gave good advice on her diabetes.",
    ms: "Sangat mudah menempah melalui WhatsApp. Doktor sangat sabar dengan ibu saya yang berusia dan memberi nasihat baik tentang diabetesnya.",
  },
];

export const Testimonials = () => {
  const { lang, t } = useLang();
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 py-20" data-testid="testimonials-section">
      <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-slate-900 mb-3">{t("testimonials.title")}</h2>
      <p className="text-base md:text-lg text-slate-500 mb-12">{t("testimonials.subtitle")}</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {testimonials.map((tm) => (
          <div key={tm.name} data-testid={`testimonial-card-${tm.name.replace(/[.\s]+/g, "-").toLowerCase()}`}
            className="bg-white rounded-2xl border border-slate-200 p-7 flex flex-col hover:-translate-y-1 hover:shadow-md transition-[transform,box-shadow]">
            <Quote className="w-7 h-7 text-emerald-200 mb-4" />
            <p className="text-sm text-slate-600 leading-relaxed flex-1">"{lang === "ms" ? tm.ms : tm.en}"</p>
            <div className="flex gap-0.5 mt-5 mb-3">
              {Array.from({ length: tm.rating }).map((_, i) => (
                <Star key={i} className="w-4 h-4 fill-amber-400 text-amber-400" />
              ))}
            </div>
            <p className="font-heading font-semibold text-slate-900 text-sm">{tm.name}</p>
            <p className="text-xs text-slate-400">{tm.area}</p>
          </div>
        ))}
      </div>
    </section>
  );
};
